export const IsIndexedSearchEnabledForLocale = (locale: string) => {
    switch (locale) {
        case "en":
            return true;
        case "es":
            return true;
        case "pt":
            return true;
        case "pt-pt":
            return true;
        default:
            return false;
    }
};
